import { Button, Icons, Modal, Space } from "@pankod/refine-antd";
import "../styles/toggle-confirmation-modal.css";

type ToggleConfirmationModalProps = {
  visible: boolean;
  enabled?: boolean;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const ToggleConfirmationModal: React.FC<ToggleConfirmationModalProps> = ({
  visible,
  enabled = false,
  loading = false,
  onCancel,
  onConfirm,
}) => {
  if (!visible) {
    return null;
  }

  const actionLabel = enabled ? "Desativar" : "Ativar";
  const Icon = enabled ? Icons.WarningOutlined : Icons.CheckCircleOutlined;
  const iconColor = enabled ? "#FF8800" : "#3F8E12";
  const title = enabled ? "Desativar funcionalidade?" : "Ativar funcionalidade?";

  return (
    <Modal
      visible={visible}
      wrapClassName="feature-flag-toggle-modal"
      width={604}
      title={
        <Space align="center" size={10}>
          <Icon style={{ color: iconColor, fontSize: 20 }} />
          <span style={{ fontSize: 20, fontWeight: 600 }}>{title}</span>
        </Space>
      }
      footer={null}
      onCancel={onCancel}
      bodyStyle={{ paddingTop: 14 }}
    >
      <div style={{ color: "#878787", fontSize: 16, lineHeight: 1.35 }}>
        {enabled ? (
          <>
            <p style={{ margin: 0 }}>
              Você está prestes a desativar esta funcionalidade no ambiente atual.
            </p>
            <p style={{ margin: 0 }}>
              Isso pode interromper fluxos ativos ou alterar o comportamento do sistema.
            </p>
            <p style={{ margin: 0 }}>Deseja continuar?</p>
          </>
        ) : (
          <>
            <p style={{ margin: 0 }}>
              Você está prestes a ativar esta funcionalidade no ambiente atual.
            </p>
            <p style={{ margin: 0 }}>
              Isso pode impactar o comportamento do sistema e a experiência dos usuários.
            </p>
            <p style={{ margin: 0 }}>Deseja continuar?</p>
          </>
        )}
      </div>

      <Space
        className="feature-flag-toggle-modal-actions"
        size={18}
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: 34,
        }}
      >
        <Button
          className="feature-flag-toggle-modal-cancel"
          onClick={onCancel}
        >
          Cancelar
        </Button>
        <Button
          className="feature-flag-toggle-modal-confirm"
          type="primary"
          loading={loading}
          onClick={onConfirm}
        >
          {actionLabel}
        </Button>
      </Space>
    </Modal>
  );
};
